import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';
import { mapCurrentUserToDialogUser } from '@common/model/dialog/mapCurrentUserToDialogUser';
import { MemberUser } from '@youhelp-ru/core';

export const getDialogMemberForUser = (members: DialogMemberViewModel[], currentUser: MemberUser): DialogMemberViewModel | undefined => {
  const mappedUser = mapCurrentUserToDialogUser(currentUser);

  return members.find((member) => member.type === mappedUser.type && member.entityId === mappedUser.id);
};

export const getAllDialogMembersForUser = (members: DialogMemberViewModel[], currentUser: MemberUser): DialogMemberViewModel[] => {
  const mappedUser = mapCurrentUserToDialogUser(currentUser);

  return members.filter((member) => member.type === mappedUser.type && member.entityId === mappedUser.id);
};
